// src/api/errors.ts

/**
 * Человекочитаемый текст ошибки API.
 *
 * Бэкенд на доменные ошибки отвечает `{ error: '...' }`, Symfony на
 * исключения — `{ message: '...' }`; всё остальное заменяем запасной
 * фразой, чтобы в диалоге не появлялось «Request failed with status code 422».
 */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
    if (typeof error !== 'object' || error === null) return fallback;

    const response = (error as { response?: { data?: unknown } }).response;
    const data = response?.data;
    if (typeof data !== 'object' || data === null) return fallback;

    const body = data as { error?: unknown; message?: unknown };
    if (typeof body.error === 'string' && body.error.trim() !== '') return body.error.trim();
    if (typeof body.message === 'string' && body.message.trim() !== '') return body.message.trim();

    return fallback;
};
